import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  load() {
    const frame = document.getElementById("details_frame")
    if (frame) {
      frame.src = this.urlValue
    }
  }
}